module.exports = __webpack_public_path__ + "img/diamonds@2x.266dcd1.webp";